const DocQueryFields = [
    {
        name: '#',
        code: '_seq_',
        column: true,
        sortable: false,
        defaultFilter: false,
        width: 60
    },
    {
        name: 'PO',
        code: 'po',
        column: true,
        sortable: true,
        align: 'center',
        defaultFilter: true,
        width: 120
    },
    {
        name: 'Factory',
        code: 'factoryName',
        column: true,
        sortable: true,
        align: 'center',
        width: 120
    },
    {
        name: 'Scaned',
        code: 'scaned',
        column: true,
        sortable: true,
        align: 'center',
        width: 120
    },
    {
        name: 'Unscan',
        code: 'unscan',
        column: true,
        sortable: true,
        align: 'center',
        width: 100
    },
    {
        name: 'Status',
        code: 'boxStatus',
        column: true,
        sortable: true,
        align: 'center',
        width: 120
    },
    {
        name: 'Carton',
        code: 'boxQuantity',
        column: true,
        listFilter: true,
        sortable: true,
        width: 120
    },
    {
        name: 'Pieces',
        code: 'pieceQuantity',
        column: true,
        listFilter: true,
        sortable: true,
        width: 120
    }
];



export default DocQueryFields;
